module.exports = __webpack_public_path__ + "img/user-8.cf241d93.svg";